!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Apply collapsible headers to icon-box on small screens.
   */
  Drupal.behaviors.iconBox = {
    attach: context => {
      $('.js-icon-box', context);
      $(once('iconBox', '.js-icon-box', context))
        .each(function() {
          const $iconBox = $(this);
          const iconBoxToggle = $iconBox.find('.js-icon-box-toggle');
          const iconBoxBody = $iconBox.find('.js-icon-box-body');
          iconBoxToggle.click(() => {
            iconBoxToggle.toggleClass('is-active');
            iconBoxBody.toggleClass('is-open');
          });
        });
    },
  };
})(document, Drupal, jQuery, once);
